import React from 'react';
import {
  KeyboardAvoidingView,
  View,
  Platform,
  ScrollView,
} from 'react-native';
import { isWeb } from '../../utils/Helper';

const KeyboardAvoidingWrapper = ({ children, style, keyboardVerticalOffset = 0 }) => {

  return isWeb() ? (
    <>
      {children}
    </>
  ) : (
    <KeyboardAvoidingView
      style={[{ flex: 1 }, style]}
      behavior={Platform.OS === 'ios' ? 'padding' : 'padding'}
      keyboardVerticalOffset={keyboardVerticalOffset}
    >

      <ScrollView
        contentContainerStyle={{ flexGrow: 1 }}
        keyboardShouldPersistTaps="handled"
        scrollEnabled={false}
        showsVerticalScrollIndicator={false}
      >
          {children}
        </ScrollView>
    </KeyboardAvoidingView>
  );
};

export default KeyboardAvoidingWrapper;